/**
  * @description 广告活动的下拉选择控件
*/
<template>
    <gj-virtual-select-more
        v-bind="$attrs"
        v-on="$listeners"
        clearable
        type="multi-check"
        :filterable="false"
        :width="width"
        :list="options"
        :loading="loading"
        :placeholder="placeholder"
        @change="changeValue"
    >
    </gj-virtual-select-more>
</template>

<script>
import {  SP, SD } from "@/api/ad.js";
export default {
  name: "ad-group-select",
  props: {
    // 广告类型
    adType: {
      type: String,
      required: true,
      validator: function (value) {
        return ['SB', 'SD', 'SP'].indexOf(value) !== -1
      }
    },
    placeholder: {
      type: String,
      default: "广告组"
    },
    width: {
      type: String,
      default: "170px"
    },
    // 站点list
    marketId: {
      type: String | Number,
      default: null
    },
    // 广告活动id
    campaignId: {
      type: String | Number,
      default: null
    }
  },
  data() {
    return {
      options: []
    };
  },
  components: {},
  methods: {
    // 获取下拉选项
    async getOptions(type, afferent = {}) {
      const types = {
        SD: () => {
          return SD.selectSdGroups 
        },
        SP: () => {
          return SP.selectSpGroups
        },
      }
      this.loading = true
      try {
        let params = {
          marketId: this.marketId,
          campaignIds: this.campaignId && [ this.campaignId ],
          ...afferent
        }
        let { data } = await types[type]()(params)
        this.options = (data || []).map(e => ({
          ...e,
          id: e.groupId,
          text: e.groupName
        }))
      } finally {
        this.loading = false
      }
    },
    changeValue(val) {
      this.$emit('input', val);
    }
  },
  created() {
    this.getOptions(this.adType)
  },
};
</script>

<style scoped lang='scss'>
</style>